import useHistory from './useHistory';
import useReturnTo from './useReturnTo';

/**
 * useExitSettings
 *
 * This hook provides a function to exit from settings pages.
 * It navigates to the return URL if it exists and doesn't include 'settings',
 * otherwise it redirects to the home page.
 *
 * @returns {Function} exit - Function to navigate to the appropriate page when exiting settings
 */
const useExitSettings = () => {
  const returnTo = useReturnTo();
  const history = useHistory();

  const exit = () => {
    if (!returnTo || returnTo?.includes('settings')) {
      // if the returnTo includes settings, we need to go to the home page
      history.push('/');
    } else {
      history.push(returnTo);
    }
  };

  return exit;
};

export default useExitSettings;
